import { ArrowRight, Phone } from "lucide-react";

export default function CTABanner({ phone }) {
  return (
    <section data-testid="cta-banner" className="bg-brand px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div className="max-w-xl">
          <h2 className="font-heading font-bold text-white text-3xl sm:text-4xl tracking-tight leading-snug">
            Ready to Transform Your Property?
          </h2>
          <p className="mt-3 text-white/90 text-lg">
            Every estimate is free — we come to you, evaluate your property, and give you a
            personalized quote. No charge, no obligation.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4 shrink-0">
          <a
            href="#estimate"
            data-testid="cta-banner-estimate-button"
            className="inline-flex items-center justify-center gap-2 bg-white text-brand font-bold rounded-full px-8 py-4 hover:bg-surface transition-colors duration-200 shadow-md"
          >
            Get a Free Estimate
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </a>
          <a
            href={`tel:${(phone || "214-576-8224").replace(/[^0-9+]/g, "")}`}
            data-testid="cta-banner-call-button"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white font-semibold rounded-full px-8 py-4 hover:bg-white hover:text-brand transition-colors duration-200"
          >
            <Phone className="w-5 h-5" aria-hidden="true" />
            {phone || "214-576-8224"}
          </a>
        </div>
      </div>
    </section>
  );
}
